module.exports = __webpack_public_path__ + "static/hero-b155ad8d7ea7985ee7de9a392492e687.jpg";